@if (previewMaterial) {
  <h2>{{ "forms.educationalResource.preview.title" | translate }}</h2>
  <dl class="row g-0">
    @if (hasName) {
      @if (previewMaterial?.name?.fi) {
        <div appPreviewRow
          [title]="'forms.educationalResource.files.materialName.label.fi' | translate"
        [item]="previewMaterial.name.fi"></div>
      }
      @if (previewMaterial?.name?.en) {
        <div appPreviewRow
          [title]="'forms.educationalResource.files.materialName.label.en' | translate"
        [item]="previewMaterial.name.en"></div>
      }
      @if (previewMaterial?.name?.sv) {
        <div appPreviewRow
          [title]="'forms.educationalResource.files.materialName.label.sv' | translate"
        [item]="previewMaterial.name.sv"></div>
      }
    } @else {
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.name" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 1]">
          {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
        </a>
      </dd>
    }
  </dl>
  <hr />
  <h3>{{ "forms.educationalResource.nav.files" | translate }}</h3>
  @if (hasMaterial) {
    <p>{{ "forms.educationalResource.preview.material-help" | translate }}</p>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th scope="col">#</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.fileOrLink" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.displayName" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.language" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.subtitles" | translate }}</th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        @for (file of previewMaterial.fileDetails; track file; let i = $index) {
          <tr cdkDrag>
            <td>
              <i class="fa fa-bars" aria-hidden="true"></i>
            </td>
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ file.file }}{{ file.link }}</td>
            <td>
              <ul class="list-unstyled">
                @if (file.displayName.fi) {
                  <li>
                    <strong>fi:</strong>
                    {{ file.displayName.fi }}
                  </li>
                }
                @if (file.displayName.sv) {
                  <li>
                    <strong>sv:</strong>
                    {{ file.displayName.sv }}
                  </li>
                }
                @if (file.displayName.en) {
                  <li>
                    <strong>en:</strong>
                    {{ file.displayName.en }}
                  </li>
                }
              </ul>
            </td>
            <td>{{ file.language }}</td>
            <td>
              @if (file.subtitles?.length > 0) {
                @for (subtitle of file.subtitles; track subtitle; let isLast = $last) {
                  <span
                    [class.fw-bold]="subtitle.default">
                    {{ subtitle.label }} ({{ subtitle.srclang }})
                    @if (!isLast) {
                      <br />
                    }
                  </span>
                }
              } @else {
                -
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <dl class="row g-0">
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.material" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 1]">
          {{ "forms.educationalResource.files.file.error" | translate }}
        </a>
      </dd>
    </dl>
  }
  <hr />
  <h3>{{ "forms.educationalResource.nav.basicDetails" | translate }}</h3>
  <dl class="row g-0">
    @if (hasAuthor) {
      @for (author of previewMaterial.authors; track author) {
        <dt class="col-sm-3">{{ "forms.educationalResource.basicDetails.author.inputs.author.label" | translate }}</dt>
        <dd class="col-sm-9">
          @if (author.author) {
            {{ author.author }}
            @if (author.organization) {
              , {{ author.organization.value }}
            }
          }
          @if (!author.author) {
            {{ author.organization.value }}
          }
        </dd>
      }
    } @else {
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.author" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 2]">
          {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
        </a>
      </dd>
    }
    @if (hasKeywords) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.keywords.label' | translate"
        [items]="previewMaterial?.keywords"
      property="value"></div>
    } @else {
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.keywords" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 2]">
          {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
        </a>
      </dd>
    }
    @if (hasLearningResourceTypes) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.learningResourceTypes.label' | translate"
        [items]="previewMaterial?.learningResourceTypes"
      property="value"></div>
    } @else {
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.learningResourceTypes" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 2]">
          {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
        </a>
      </dd>
    }
    @if (previewMaterial?.educationalRoles?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.educationalRoles.label' | translate"
        [items]="previewMaterial.educationalRoles"
      property="value"></div>
    }
    @if (previewMaterial?.educationalUses?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.basicDetails.educationalUses.label' | translate"
        [items]="previewMaterial.educationalUses"
      property="value"></div>
    }
    @if (previewMaterial?.description) {
      @if (previewMaterial?.description?.fi) {
        <div appPreviewRow
          [title]="'forms.educationalResource.basicDetails.description.label.fi' | translate"
        [item]="previewMaterial.description.fi"></div>
      }
      @if (previewMaterial?.description?.en) {
        <div appPreviewRow
          [title]="'forms.educationalResource.basicDetails.description.label.en' | translate"
        [item]="previewMaterial.description.en"></div>
      }
      @if (previewMaterial?.description?.sv) {
        <div appPreviewRow
          [title]="'forms.educationalResource.basicDetails.description.label.sv' | translate"
        [item]="previewMaterial.description.sv"></div>
      }
    }
  </dl>
  <hr />
  <h3>{{ "forms.educationalResource.nav.educationalDetails" | translate }}</h3>
  <dl class="row g-0">
    @if (hasEducationalLevels) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.educationalLevels.label' | translate"
        [items]="previewMaterial?.educationalLevels"
      property="value"></div>
    } @else {
      <dt class="col-sm-3">{{ "forms.educationalResource.preview.required.educationalLevels" | translate }}</dt>
      <dd class="col-sm-9">
        <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
        <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 3]">
          {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
        </a>
      </dd>
    }
    <!-- early childhood education -->
    @if (previewMaterial?.earlyChildhoodEducationSubjects?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.subjects.label' | translate"
        [items]="previewMaterial.earlyChildhoodEducationSubjects"
      property="targetName"></div>
    }
    @if (previewMaterial?.earlyChildhoodEducationObjectives?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.objectives.label' | translate
      "
        [items]="previewMaterial.earlyChildhoodEducationObjectives"
      property="targetName"></div>
    }
    @if (previewMaterial?.suitsAllEarlyChildhoodSubjects) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.earlyChildhoodEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.earlyChildhoodEducationFramework) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.earlyChildhoodEducation.inputs.framework.label' | translate
      "
      [item]="previewMaterial.earlyChildhoodEducationFramework"></div>
    }
    <!-- pre-primary education -->
    @if (previewMaterial.prePrimaryEducationSubjects?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.subjects.label' | translate"
        [items]="previewMaterial.prePrimaryEducationSubjects"
      property="targetName"></div>
    }
    @if (previewMaterial.prePrimaryEducationObjectives?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.objectives.label' | translate"
        [items]="previewMaterial.prePrimaryEducationObjectives"
      property="targetName"></div>
    }
    @if (previewMaterial?.suitsAllPrePrimarySubjects) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.prePrimaryEducationFramework) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.prePrimaryEducation.inputs.framework.label' | translate"
      [item]="previewMaterial.prePrimaryEducationFramework"></div>
    }
    <!-- basic education -->
    @if (previewMaterial?.basicStudySubjects?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.subjects.label' | translate"
        [items]="previewMaterial.basicStudySubjects"
      property="targetName"></div>
    }
    @if (shouldHaveBasicEduObjectivesAndContents || hasBasicEduObjectives) {
      <dt class="col-sm-3">
        {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.objectives.label" | translate }}
      </dt>
      <dd class="col-sm-9">
        @if (hasBasicEduObjectives) {
          @for (objective of previewMaterial.basicStudyObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}
            @if (!isLast) {
              <br />
            }
          }
        }
        @if (shouldHaveBasicEduObjectivesAndContents && !hasBasicEduObjectives) {
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 3]">
            {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
          </a>
        }
      </dd>
    }
    @if (shouldHaveBasicEduObjectivesAndContents || hasBasicEduContents) {
      <dt class="col-sm-3">
        {{ "forms.educationalResource.educationalDetails.basicEducation.inputs.contents.label" | translate }}
      </dt>
      <dd class="col-sm-9">
        @if (hasBasicEduContents) {
          @for (content of previewMaterial.basicStudyContents; track content; let isLast = $last) {
            {{ content.targetName }}
            @if (!isLast) {
              <br />
            }
          }
        }
        @if (shouldHaveBasicEduObjectivesAndContents && !hasBasicEduContents) {
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 3]">
            {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
          </a>
        }
      </dd>
    }
    @if (previewMaterial?.suitsAllBasicStudySubjects) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.basicEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.basicStudyFramework) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.basicEducation.inputs.framework.label' | translate"
      [item]="previewMaterial.basicStudyFramework"></div>
    }
    <!-- preparatory education -->
    @if (previewMaterial?.preparatoryEducationSubjects?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.preparatoryEducation.inputs.subjects.label' | translate"
        [items]="previewMaterial.preparatoryEducationSubjects"
      property="targetName"></div>
    }
    @if (previewMaterial?.preparatoryEducationObjectives?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.preparatoryEducation.inputs.objectives.label' | translate"
        [items]="previewMaterial.preparatoryEducationObjectives"
      property="targetName"></div>
    }
    <!-- upper secondary education -->
    @if (previewMaterial?.upperSecondarySchoolSubjectsOld?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label'
          | translate
      "
        [items]="previewMaterial.upperSecondarySchoolSubjectsOld"
      property="targetName"></div>
    }
    <!--upperSecondarySchoolSubjectsOld-->
    @if (previewMaterial?.upperSecondarySchoolCoursesOld?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.subjects.label' | translate
      "
        [items]="previewMaterial.upperSecondarySchoolCoursesOld"
      property="targetName"></div>
    }
    <!--upperSecondarySchoolCoursesOld-->
    @if (previewMaterial?.upperSecondarySchoolObjectives?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.objectives.label' | translate
      "
        [items]="previewMaterial.upperSecondarySchoolObjectives"
      property="targetName"></div>
    }
    @if (previewMaterial?.suitsAllUpperSecondarySubjects) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.upperSecondarySchoolFramework) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.label' | translate
      "
      [item]="previewMaterial.upperSecondarySchoolFramework"></div>
    }
    <!-- upper secondary education (LOPS2019) -->
    @if (previewMaterial?.upperSecondarySchoolSubjectsNew?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.subjects.label'
          | translate
      "
        [items]="previewMaterial.upperSecondarySchoolSubjectsNew"
      property="targetName"></div>
    }
    @if (previewMaterial?.upperSecondarySchoolModulesNew?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.modules.label'
          | translate
      "
        [items]="previewMaterial.upperSecondarySchoolModulesNew"
      property="targetName"></div>
    }
    @if (shouldHaveUppSecondaryEduObjectivesAndContents || hasUpperSecondaryEduObjectives) {
      <dt class="col-sm-3">
        {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.objectives.label" |
        translate }}
      </dt>
      <dd class="col-sm-9">
        @if (hasUpperSecondaryEduObjectives) {
          @for (objective of previewMaterial.upperSecondarySchoolObjectivesNew; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        }
        @if (shouldHaveUppSecondaryEduObjectivesAndContents && !hasUpperSecondaryEduObjectives) {
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 3]">
            {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
          </a>
        }
      </dd>
    }
    @if (shouldHaveUppSecondaryEduObjectivesAndContents || hasUpperSecondaryEduContents) {
      <dt class="col-sm-3">
        {{ "forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.new.contents.label" |
        translate }}
      </dt>
      <dd class="col-sm-9">
        @if (hasUpperSecondaryEduContents) {
          @for (content of previewMaterial.upperSecondarySchoolContentsNew; track content; let isLast = $last) {
            {{ content.targetName }}{{ isLast ? "" : ", " }}
          }
        }
        @if (shouldHaveUppSecondaryEduObjectivesAndContents && !hasUpperSecondaryEduContents) {
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/muokkaa-oppimateriaalia', materialId, 3]">
            {{ "forms.educationalResource.preview.addMissingDetail" | translate }}
          </a>
        }
      </dd>
    }
    @if (previewMaterial?.newUpperSecondarySchoolFramework) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.upperSecondarySchoolEducation.inputs.framework.label' | translate
      "
      [item]="previewMaterial.newUpperSecondarySchoolFramework"></div>
    }
    <!-- vocational education -->
    @if (previewMaterial?.vocationalDegrees?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.degrees.label' | translate"
        [items]="previewMaterial.vocationalDegrees"
      property="targetName"></div>
    }
    @if (previewMaterial?.furtherVocationalQualifications?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.vocationalEducation.inputs.furtherVocationalQualifications.label'
          | translate
      "
        [items]="previewMaterial.furtherVocationalQualifications"
      property="targetName"></div>
    }
    @if (previewMaterial?.specialistVocationalQualifications?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.vocationalEducation.inputs.specialistVocationalQualifications.label'
          | translate
      "
        [items]="previewMaterial.specialistVocationalQualifications"
      property="targetName"></div>
    }
    @if (previewMaterial.vocationalCommonUnits?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.commonUnits.label' | translate"
        [items]="previewMaterial.vocationalCommonUnits"
      property="targetName"></div>
    }
    @if (previewMaterial?.vocationalUnits?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.units.label' | translate"
        [items]="previewMaterial.vocationalUnits"
      property="targetName"></div>
    }
    @if (previewMaterial?.vocationalRequirements?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.objectives.label' | translate"
        [items]="previewMaterial.vocationalRequirements"
      property="targetName"></div>
    }
    <!--vocationalRequirements-->
    @if (previewMaterial?.suitsAllVocationalDegrees) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.vocationalEducationFramework) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.vocationalEducation.inputs.framework.label' | translate"
      [item]="previewMaterial.vocationalEducationFramework"></div>
    }
    <!-- self-motivated education -->
    @if (previewMaterial?.selfMotivatedEducationSubjects?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.subjects.label' | translate"
        [items]="previewMaterial.selfMotivatedEducationSubjects"
      property="targetName"></div>
    }
    @if (previewMaterial?.selfMotivatedEducationObjectives?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.selfMotivatedEducation.inputs.objectives.label' | translate
      "
        [items]="previewMaterial.selfMotivatedEducationObjectives"
      property="targetName"></div>
    }
    @if (previewMaterial?.suitsAllSelfMotivatedSubjects) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.selfMotivatedEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    <!-- higher education-->
    @if (previewMaterial?.branchesOfScience?.length > 0) {
      <div appPreviewRow
      [title]="
        'forms.educationalResource.educationalDetails.higherEducation.inputs.branchesOfScience.label' | translate
      "
        [items]="previewMaterial.branchesOfScience"
      property="targetName"></div>
    }
    @if (previewMaterial?.scienceBranchObjectives?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.higherEducation.inputs.objectives.label' | translate"
        [items]="previewMaterial.scienceBranchObjectives"
      property="targetName"></div>
    }
    @if (previewMaterial?.suitsAllBranches) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.higherEducation.title' | translate"
      [item]="'forms.educationalResource.educationalDetails.common.suitsAllSubjects' | translate"></div>
    }
    @if (previewMaterial?.higherEducationFramework?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.educationalDetails.higherEducation.inputs.framework.label' | translate"
      [item]="previewMaterial.higherEducationFramework"></div>
    }
  </dl>
  <hr />
  <h3>{{ "forms.educationalResource.nav.extendedDetails" | translate }}</h3>
  <dl class="row g-0">
    @if (previewMaterial?.accessibilityFeatures?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.accessibility.inputs.features.label' | translate"
        [items]="previewMaterial.accessibilityFeatures"
      property="value"></div>
    }
    @if (previewMaterial?.accessibilityHazards?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.accessibility.inputs.hazards.label' | translate"
        [items]="previewMaterial.accessibilityHazards"
      property="value"></div>
    }
    @if (typicalAgeRange) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.typicalAgeRange.label' | translate"
      [item]="typicalAgeRange"></div>
    }
    @if (previewMaterial?.timeRequired) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.timeRequired.label' | translate"
      [item]="previewMaterial.timeRequired"></div>
    }
    @if (previewMaterial?.publisher?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.publisher.label' | translate"
        [items]="previewMaterial.publisher"
      property="value"></div>
    }
    @if (previewMaterial?.expires) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.expires.label' | translate"
      [item]="previewMaterial.expires | date: 'd.M.yyyy'"></div>
    }
    @if (previewMaterial?.prerequisites?.length > 0) {
      <div appPreviewRow
        [title]="'forms.educationalResource.extendedDetails.prerequisites.label' | translate"
        [items]="previewMaterial.prerequisites"
      property="targetName"></div>
    }
  </dl>
  <hr />
  @if (previewMaterial.externals) {
    <h3>{{ "forms.educationalResource.nav.basedOnDetails" | translate }}</h3>
    <dl class="row g-0">
      @for (external of previewMaterial.externals; track external; let i = $index) {
        <dt class="col-sm-3">{{ i + 1 }}. materiaali</dt>
        <dd class="col-sm-9">
          <dl class="row g-0">
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.name.label" | translate }}
            </dt>
            <dd class="col-sm-9">{{ external.name }}</dd>
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.author.label" | translate }}
            </dt>
            <dd class="col-sm-9">
              @for (author of external.author; track author; let isLast = $last) {
                {{ author }}
                @if (!isLast) {
                  <span>,</span>
                }
              }
            </dd>
            <dt class="col-sm-3">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.link.label" | translate }}
            </dt>
            <dd class="col-sm-9">
              <a [href]="external.url" target="_blank" rel="noopener">{{ external.url }}</a>
            </dd>
          </dl>
        </dd>
      }
    </dl>
    <hr />
  }
  <h3>{{ "forms.educationalResource.nav.licenseDetails" | translate }}</h3>
  <dl class="row g-0">
    <div appPreviewRow
      [title]="'forms.educationalResource.license.title' | translate"
      [item]="previewMaterial?.license"
      [required]="!hasLicense"
    [routerLinkOptions]="['/muokkaa-oppimateriaalia', materialId, 5]"></div>
  </dl>
  <hr />
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="confirm" formControlName="confirm" />
      <label class="form-check-label" for="confirm">
        {{ "forms.educationalResource.preview.confirm" | translate }}
      </label>
      <ul>
        @switch (lang) {
          @default {
            <li>kaikki tekijät ovat hyväksyneet materiaalin julkaisun avoimella lisenssillä,</li>
            <li>
              muiden tekijöiden aineistot (esim. kuvat) voidaan julkaista avoimesti joko aineistojen oman avoimen
              lisenssin tai erikseen saadun luvan perusteella,
            </li>
            <li>
              materiaalissa näkyvien henkilöiden kuvien tai muiden henkilötietojen osalta lupa julkaisuun on saatu ko.
              henkilöiltä ja
            </li>
            <li>materiaali on parhaan tietomme mukaan alan hyvien tapojen mukainen</li>
          }
          @case ('en') {
            <li>all authors have agreed to publish the OER with an open licence</li>
            <li>
              I have permission to use materials made by others that are included in my material (f.ex. pictures)
              through licence or other agreement
            </li>
            <li>I have gained permission from the relevant parties to include any personal data included in the OER</li>
            <li>the OER is according to our best knowledge made with best practices of our field</li>
          }
          @case ('sv') {
            <li>fått tillåtelse från alla upphovspersoner att publicera lärresurs med en Creative Commons licens</li>
            <li>tillåtelse att använda alla materialen i min lärresurs (till exemple bilder)</li>
            <li>
              fått tillåtelse från alla personer att publicera deras personuppgift (om jag har personuppgift i min
              lärresurs)
            </li>
            <li>gjort lärresursen, enligt vår bästa kunskap, med den bästa praxis inom vårt område</li>
          }
        }
      </ul>
    </div>
    @if (saveError) {
      <div class="alert alert-danger text-center" role="alert">{{ saveError }}</div>
    }
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">
          {{ "forms.common.previous" | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue" [disabled]="form.invalid">
          {{ "forms.common.save" | translate }}
        </button>
      </div>
    </div>
  </form>
}
